import { getOr } from 'lodash/fp'

import config from '@config'
import { useSettings } from '@queries/settings'

export const useVgsVaultId = (): string => {
  const [
    {
      paymentProvidersMethods: { creditCard },
    },
  ] = useSettings()
  return getOr(config.vgs.vaultId, 'options.vaultId', creditCard)
}
